import script from "./BriefcaseUserList.vue?vue&type=script&setup=true&lang=js"
export * from "./BriefcaseUserList.vue?vue&type=script&setup=true&lang=js"

import "./BriefcaseUserList.vue?vue&type=style&index=0&id=1bbbcda2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bbbcda2"]])

export default __exports__